// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1bNRU","ranges":"BmiRanges_ranges__12wMB"};